$(document).ready(function(){
$('.navbar-toggler').click(function(){
$('.navbar-toggler').toggleClass('showtoggle');
});	

$('.srcop').click(function(){
$('.openSrch').toggleClass('actv');
});	
$('.cls').click(function(){
$('.openSrch').removeClass('actv');
});	
$('.filterMob').click(function(){
$('.siteBar').toggleClass('actv');
});


});	

//$(window).scroll(function() {    
   // var scroll = $(window).scrollTop();

   // if (scroll >= 30) {
   //     $(".header_sec").addClass("fixed");
   // } else {
   //     $(".header_sec").removeClass("fixed");
   // }
//});

const header = document.querySelector(".header_sec");
const toggleClass = "is-sticky";

window.addEventListener("scroll", () => {
  const currentScroll = window.pageYOffset;
  if (currentScroll > 150) {
    header.classList.add(toggleClass);
  } else {
    header.classList.remove(toggleClass);
  }
});


$(document).ready(function() {
var owl = $('.product_caro .owl-carousel');
  owl.owlCarousel({
    margin:30,
    dots: false,
    center: true,
    autoplay: false,
    nav: true,
    dotsEach: false,
    loop: true,
    responsive: {
      0: {	
      	margin:20,
      	center: false,
      	autoHeight: true,
        items: 1
      },
      481: {	
      	margin:20,
      	center: false,
        items: 2
      },
      576: {	
      	margin:20,
      	center: false,
        items: 2
      },
      768: {
      	center: false,
      	margin:20,
        items: 2
      },         
      992: {
        items: 3
      },
      1200: {
        items: 3
      }
    }
  });
});


